import safeCreateAction from "../../actions/safeCreateAction";
/**
 * add a metaserver
 */
export const addMetaserver = safeCreateAction("ADD_METASERVER", (id, url) => ({ id, url }));
/**
 * remove a metaserver
 */
export const removeMetaserver = safeCreateAction("REMOVE_METASERVER", (id, cacheDurationSec) => ({ id, cacheDurationSec }));
/**
 * change the priority of a metaserver
 */
export const setPriorities = safeCreateAction("SET_METASERVER_PRIORITY", (ids) => ({ ids }));
